<template>
    <div
        class="aspect-square transition-transform duration-1000 ease-in-out"
        :style="{ transform: `rotate(${rotation}deg) scale(${scale})` }"
    >
        <PatternNew :columns="3" :rows="3" variant="default" :isAnimated="true" :seed="seed" />
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import PatternNew from './PatternNew.vue'

const rotation = ref(0)
const scale = ref(1)
const seed = ref(Date.now())

let intervalId: ReturnType<typeof setInterval> | null = null

onMounted(() => {
    intervalId = setInterval(() => {
        rotation.value += 90
        scale.value = scale.value === 1 ? 0.75 : 1
        seed.value = Math.floor(Math.random() * 1e9)
    }, 1000)
})

onUnmounted(() => {
    if (intervalId) clearInterval(intervalId)
})
</script>
